module.exports = __webpack_public_path__ + "img/5_14.c78d1c74.png";